import React from 'react';
import fileDownload from 'react-file-download';
import { toast } from 'react-toastify';
import api from '../irelandApi';
import {
  GET_PIP_EPOS_OBJECTIVES_LIST_PENDING,
  GET_PIP_EPOS_OBJECTIVES_LIST_FULFILLED,
  GET_PIP_EPOS_OBJECTIVES_LIST_REJECTED
} from '../reducers/pipEposObjectivesReducer';
import ToastMessage from '../components/common/toast-message';

const adminPipEposSubmissionUrl = '/api/admin/data_import_postcodeplan_objectives';

export const getPipEposObjectives = (objectiveName, startDateFrom, endDateTo) => (dispatch) => {
  dispatch({ type: GET_PIP_EPOS_OBJECTIVES_LIST_PENDING });

  const query = {
    name: objectiveName,
    start_date_from: startDateFrom,
    end_date_to: endDateTo
  };

  return api.get(`${adminPipEposSubmissionUrl}`, { params: { q: query } })
    .then((response) => {
      dispatch({
        type: GET_PIP_EPOS_OBJECTIVES_LIST_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PIP_EPOS_OBJECTIVES_LIST_REJECTED,
        payload: error.response
      });
    });
};

export const downloadPipEposObjectives = (objectiveName, startDateFrom, endDateTo) => () => {
  const query = {
    name: objectiveName,
    start_date_from: startDateFrom,
    end_date_to: endDateTo
  };

  return api.get(`${adminPipEposSubmissionUrl}.csv`, { params: { q: query } })
    .then((response) => {
      const fileName = 'pip_epos_objectives.csv';

      fileDownload(response.data, fileName);
    })
    .catch((error) => {
      toast.error(<ToastMessage
        iconStyle="error"
        message={`Pip Epos Objectives can not be downloaded: ${error.response.data.errors[0]}`}
      />);
    });
};
